export const navigate = (queryPath: string, extra?: Record<string, string>) => {
    // Construct URLSearchParams object instance from current URL querystring.
    var queryParams = new URLSearchParams(window.location.search);
    // Set new or modify existing parameter value.
    const oldQueryPath = queryParams.get("queryPath");
    let sameQueries = true;
    if (extra) {
        for (let _key of Object.keys(extra)) {
            const val = queryParams.get(_key);
            if (val !== extra[_key]) {
                sameQueries = val === extra[_key];
            }
        }
        for (let _key of Object.keys(extra)) {
            queryParams.set(_key, extra[_key]);
        }
    }
    if (queryPath !== '') {
        queryParams.set("queryPath", queryPath);
    }
    // Replace current querystring with the new one.
    if (oldQueryPath !== queryPath || !sameQueries) {
        window.history.pushState(null, "", "?" + queryParams.toString());
        let queryStringChange = new Event('popstate');
        window.dispatchEvent(queryStringChange);
    }
}

export const goBack = () => {
    window.history.back();
}
